<script >
import UiPopover from '@futuweb/future-ui/es/popover';
import '@futuweb/future-ui/es/popover/style/css';
import { ref, onMounted, onBeforeUnmount } from 'vue-demi';
const __sfc_main = {};
__sfc_main.props = {
  title: Object
};
__sfc_main.setup = (__props, __ctx) => {
  // 动态计算是否需要显示tips
  const contentRef = ref();
  const shouldShowTips = ref(false);
  onMounted(() => {
    const $content = contentRef.value;
    if ($content && $content.scrollWidth > $content.clientWidth) {
      shouldShowTips.value = true;
    }
  });

  // tips显示隐藏
  const visible = ref(false);
  const showTips = () => {
    if (shouldShowTips.value) {
      visible.value = true;
    }
  };
  const hideTips = () => {
    visible.value = false;
  };
  onBeforeUnmount(() => {
    visible.value = false;
  });
  return {
    contentRef,
    visible,
    showTips,
    hideTips
  };
};
__sfc_main.components = Object.assign({
  UiPopover
}, __sfc_main.components);
export default __sfc_main;
</script>
<template>
    <ui-popover
        trigger="hover"
        :title="title"
        placement="bottom"
        v-model="visible"
    >
        <p ref="contentRef" class="content" @mouseenter="showTips" @mouseleave="hideTips">{{ title }}</p>
    </ui-popover>
</template>
<style lang="less" scoped>
.content {
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>
